import React from 'react';
import Clamp from 'react-multiline-clamp';
import common from '../../common/common';
import { get } from 'lodash';
import { generateCmsUrl } from '../../services/cms/cmsService';

const BlogPostCard = ({ blogPost }) => {
    const imageUrl = generateCmsUrl(
        get(blogPost, 'mainImage.data.attributes.url')
    );
    return (
        <div className='blog-posts-category-item'>
            <a href={`${common.getSiteUrl()}/news/${blogPost.slug}`}>
                <div className='blog-posts-category-item-text'>
                    <div>
                        <h2>{blogPost.mainCreativeWork.headline}</h2>

                        <Clamp lines={2}>
                            <p className='blog-posts-category-item-alternative-headline'>
                                {blogPost.mainCreativeWork.alternativeHeadline}
                            </p>
                        </Clamp>
                    </div>
                    <span className='blog-posts-category-item-info'>
                        <small> {blogPost.mainCreativeWork.author}</small>
                        &nbsp;|&nbsp;
                        <small className='blog-posts-category-item-published-date'>
                            {new Date(
                                blogPost.mainCreativeWork.datePublished
                            ).toLocaleDateString()}
                        </small>
                    </span>
                </div>
                <div className='blog-posts-category-item-image-container'>
                    <div className='blog-posts-category-item-image-wrapper'>
                        <picture>
                            <source srcSet={imageUrl} />
                            <img
                                className='blog-posts-category-item-animated-image'
                                itemProp='blog-posts-category-item-image'
                                src={imageUrl}
                            />
                        </picture>
                    </div>
                </div>
            </a>
        </div>
    );
};

export default BlogPostCard;
